import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { 
  FaFacebookF, 
  FaTwitter, 
  FaInstagram, 
  FaLinkedinIn,
  FaYoutube,
  FaWhatsapp,
  FaMapMarkerAlt,
  FaPhone,
  FaEnvelope,
  FaClock,
  FaCcVisa,
  FaCcMastercard,
  FaCcAmex,
  FaCcPaypal,
  FaGooglePay,
  FaApplePay,
  FaTelegram,
  FaArrowRight,
  FaShieldAlt,
  FaStar,
  FaHeart,
  FaCode
} from 'react-icons/fa';
import { 
  MdLocalTaxi, 
  MdAirportShuttle,
  MdOutlineSecurity,
  MdSupportAgent,
  MdEmail,
  MdLocationOn
} from 'react-icons/md';
import { BiRupee } from 'react-icons/bi';
import { motion } from 'framer-motion';
import logo from "../assets/WhatsApp_Image_2026-02-24_at_10.33.50_AM-removebg-preview.png"
import logo1 from "../assets/newlogoo.13718ece22099e072453.png" // Add your developer logo here

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  // Developer details
  const developer = {
    name: 'FreelancerX',
    website: 'https://freelancerx.in',
    // role: 'Developer'
  };

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (email) {
      console.log('Subscribed:', email);
      setSubscribed(true);
      setEmail('');
      setTimeout(() => setSubscribed(false), 3000);
    }
  };

  const quickLinks = [
    { name: 'About Us', path: '/about' },
    { name: 'Our Fleet', path: '/' },
    { name: 'Airport Transfer', path: '/services/airport-transfer' },
    { name: 'Outstation Trips', path: '/services/outstation-trips' },
    { name: 'Local Packages', path: '/services/local' },
    { name: 'Tour Packages', path: '/services/local' },
    { name: 'Contact Us', path: '/contact' },
    { name: 'Privacy Policy', path: '/' },
    { name: 'Terms & Conditions', path: '/' },
  ];

  const popularRoutes = [
    { name: 'Chennai to Pondicherry', price: '₹3,500' },
    { name: 'Chennai to Tirupati', price: '₹4,200' },
    { name: 'Chennai to Thiruvananthapuram', price: '₹2,800' },
    { name: 'Chennai to Tiruvanamalai', price: '₹5,500' },
    { name: 'Chennai to Mahabalipuram', price: '₹8,500' },
    { name: 'Chennai to Bangalore', price: '₹3,200' },
  ];

  const contactInfo = [
    { icon: <FaPhone />, text: '+91 91504 10309', link: 'tel:+919150410309' },
    { icon: <FaWhatsapp />, text: '+91 91504 10309', link: 'https://wa.me/919150410309' },
    { icon: <FaEnvelope />, text: 'safetrackcabservice@gmail.com', link: 'safetrackcabservice@gmail.com' },
    { icon: <FaMapMarkerAlt />, text: 'Chennai, Tamil Nadu, India', link: 'https://maps.google.com/?q=Chennai' },
    { icon: <FaClock />, text: '24/7 Available', link: null },
  ];

  const socialLinks = [
    { icon: <FaFacebookF />, url: 'https://facebook.com/safetrackcabs', label: 'Facebook' },
    { icon: <FaTwitter />, url: 'https://twitter.com/safetrackcabs', label: 'Twitter' },
    { icon: <FaInstagram />, url: 'https://instagram.com/safetrackcabs', label: 'Instagram' },
    { icon: <FaLinkedinIn />, url: 'https://linkedin.com/company/safetrackcabs', label: 'LinkedIn' },
    { icon: <FaYoutube />, url: 'https://youtube.com/safetrackcabs', label: 'YouTube' },
    { icon: <FaTelegram />, url: 'https://t.me/safetrackcabs', label: 'Telegram' },
  ];

  const paymentMethods = [
    { icon: <BiRupee />, name: 'Cash' },
    { icon: <FaCcVisa />, name: 'Visa' },
    { icon: <FaCcMastercard />, name: 'Mastercard' },
    { icon: <FaCcAmex />, name: 'Amex' },
    { icon: <FaGooglePay />, name: 'Google Pay' },
    { icon: <FaApplePay />, name: 'Apple Pay' },
    { icon: <FaCcPaypal />, name: 'PayPal' },
  ];

  return (
    <footer className="bg-gradient-to-b from-gray-900 to-black text-white pt-16 pb-6">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12 mb-12">
          
          {/* Company Info */}
          <div className="space-y-6">
            <div className="flex items-center space-x-2">
              <div className="w-20 h-20 bg-gray-100 rounded-lg flex items-center justify-center">
                <img src={logo} alt="Safe Track Logo" className="w-20 h-20" />
              </div>
            </div>
            
            <p className="text-gray-400 text-sm leading-relaxed">
              Your trusted partner for safe and comfortable rides across Chennai and Tamil Nadu. 
              24/7 availability with professional drivers and well-maintained fleet.
            </p>
            
            <div className="flex items-center space-x-1">
              {[1, 2, 3, 4, 5].map((star) => (
                <FaStar key={star} className="text-yellow-500 text-sm" />
              ))}
              <span className="text-gray-400 text-sm ml-2">4.9 (10k+ reviews)</span>
            </div>
            
            <div className="flex items-center space-x-2">
              <FaShieldAlt className="text-green-500" />
              <span className="text-sm text-gray-300">ISO 27001 Certified</span>
            </div>
          </div>
          
          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold text-white mb-6 relative inline-block">
              Quick Links
              <span className="absolute bottom-0 left-0 w-12 h-0.5 bg-yellow-500"></span>
            </h3>
            <ul className="space-y-3">
              {quickLinks.slice(0, 6).map((link) => (
                <li key={link.name}>
                  <Link 
                    to={link.path}
                    className="text-gray-400 hover:text-yellow-500 transition-colors duration-300 text-sm flex items-center group"
                  >
                    <span className="w-1 h-1 bg-yellow-500 rounded-full mr-2 opacity-0 group-hover:opacity-100 transition-opacity"></span>
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          
          {/* Popular Routes */}
          {/* <div>
            <h3 className="text-lg font-semibold text-white mb-6 relative inline-block">
              Popular Routes
              <span className="absolute bottom-0 left-0 w-12 h-0.5 bg-yellow-500"></span>
            </h3>
            <ul className="space-y-3">
              {popularRoutes.map((route) => (
                <li key={route.name}>
                  <Link 
                    to={`/route/${route.name.toLowerCase().replace(/\s+/g, '-')}`}
                    className="text-gray-400 hover:text-yellow-500 transition-colors duration-300 text-sm flex justify-between items-center group"
                  >
                    <span className="flex items-center">
                      <span className="w-1 h-1 bg-yellow-500 rounded-full mr-2 opacity-0 group-hover:opacity-100 transition-opacity"></span>
                      {route.name}
                    </span>
                    <span className="text-yellow-500 text-xs font-semibold">{route.price}</span>
                  </Link>
                </li>
              ))}
            </ul>
            <Link 
              to="/outstation"
              className="inline-flex items-center text-yellow-500 text-sm mt-4 hover:text-yellow-400 transition-colors"
            >
              View All Routes <FaArrowRight className="ml-2 text-xs" />
            </Link>
          </div> */}
          
          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold text-white mb-6 relative inline-block">
              Contact Us
              <span className="absolute bottom-0 left-0 w-12 h-0.5 bg-yellow-500"></span>
            </h3>
            <ul className="space-y-4">
              {contactInfo.map((item, index) => (
                <li key={index}>
                  {item.link ? (
                    <a 
                      href={item.link}
                      target={item.link.startsWith('http') ? '_blank' : '_self'}
                      rel="noopener noreferrer"
                      className="flex items-start space-x-3 text-gray-400 hover:text-yellow-500 transition-colors duration-300 group"
                    >
                      <span className={`mt-1 ${item.icon.type === FaWhatsapp ? 'text-green-500' : ''}`}>
                        {item.icon}
                      </span>
                      <span className="text-sm break-all">{item.text}</span>
                    </a>
                  ) : (
                    <div className="flex items-start space-x-3 text-gray-400">
                      <span className="mt-1">{item.icon}</span>
                      <span className="text-sm">{item.text}</span>
                    </div>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>
        
        {/* Newsletter & Social Links */}
        <div className="border-t border-gray-800 pt-8 pb-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            
            {/* Newsletter */}
            <div>
              <h4 className="text-white font-semibold mb-3">Subscribe to our newsletter</h4>
              <p className="text-gray-400 text-sm mb-4">
                Get updates on new routes, offers, and discounts
              </p>
              <form onSubmit={handleSubscribe} className="flex flex-col sm:flex-row gap-3">
                <div className="flex-1 relative">
                  <MdEmail className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500" />
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Enter your email"
                    className="w-full pl-10 pr-4 py-3 bg-gray-800 border border-gray-700 rounded-lg focus:outline-none focus:border-yellow-500 text-white text-sm"
                    required
                  />
                </div>
                <motion.button
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                  type="submit"
                  className="bg-yellow-500 hover:bg-yellow-600 text-black font-semibold px-6 py-3 rounded-lg transition-colors duration-300 text-sm whitespace-nowrap"
                >
                  Subscribe
                </motion.button>
              </form>
              {subscribed && (
                <p className="text-green-500 text-sm mt-2">✓ Successfully subscribed!</p>
              )}
            </div>
            
            {/* Social Links */}
            {/* <div className="lg:text-right">
              <h4 className="text-white font-semibold mb-3 lg:text-right">Follow Us</h4>
              <div className="flex flex-wrap gap-3 lg:justify-end">
                {socialLinks.map((social) => (
                  <motion.a
                    key={social.label}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    whileHover={{ y: -3 }}
                    className="w-10 h-10 bg-gray-800 hover:bg-yellow-500 rounded-lg flex items-center justify-center text-gray-400 hover:text-black transition-all duration-300"
                    aria-label={social.label}
                  >
                    {social.icon}
                  </motion.a>
                ))}
              </div>
              
             
              <div className="mt-6 flex flex-wrap gap-3 lg:justify-end">
                <motion.a
                  href="#"
                  whileHover={{ scale: 1.02 }}
                  className="inline-flex items-center space-x-2 bg-black border border-gray-700 rounded-lg px-4 py-2 hover:border-yellow-500 transition-colors"
                >
                  <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
                  </svg>
                  <div className="text-left">
                    <p className="text-xs text-gray-400">Download on</p>
                    <p className="text-sm font-semibold">App Store</p>
                  </div>
                </motion.a>
                
                <motion.a
                  href="#"
                  whileHover={{ scale: 1.02 }}
                  className="inline-flex items-center space-x-2 bg-black border border-gray-700 rounded-lg px-4 py-2 hover:border-yellow-500 transition-colors"
                >
                  <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M3 20.5v-17l13-3v23l-13-3zM17 6h2v12h-2z" />
                  </svg>
                  <div className="text-left">
                    <p className="text-xs text-gray-400">Get it on</p>
                    <p className="text-sm font-semibold">Google Play</p>
                  </div>
                </motion.a>
              </div>
            </div> */}
          </div>
        </div>
        
        {/* Payment Methods & Trust Badges */}
        <div className="border-t border-gray-800 pt-6 pb-4">
          <div className="flex flex-col lg:flex-row justify-between items-center gap-4">
            
            {/* Payment Methods */}
            <div className="flex flex-wrap items-center justify-center gap-4">
              <span className="text-gray-400 text-sm">We Accept:</span>
              <div className="flex flex-wrap gap-3">
                {paymentMethods.map((method, index) => (
                  <div
                    key={index}
                    className="text-gray-100 hover:text-yellow-500 transition-colors text-xl"
                    title={method.name}
                  >
                    {method.icon}
                  </div>
                ))}
              </div>
            </div>
            
            {/* Trust Badges */}
            <div className="flex flex-wrap gap-4 justify-center">
              <div className="flex items-center space-x-1 text-gray-400 text-sm">
                <MdOutlineSecurity className="text-green-500" />
                <span>SSL Secure</span>
              </div>
              <div className="flex items-center space-x-1 text-gray-400 text-sm">
                <MdSupportAgent className="text-yellow-500" />
                <span>24/7 Support</span>
              </div>
              <div className="flex items-center space-x-1 text-gray-400 text-sm">
                <FaStar className="text-yellow-500" />
                <span>4.9 Rating</span>
              </div>
            </div>
          </div>
        </div>
        
        {/* Copyright & Legal */}
        <div className="border-t border-gray-800 pt-6 mt-2">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-500">
            <p>
              © {currentYear} Safe Track Cab Service. All rights reserved.
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <Link to="/privacy" className="hover:text-yellow-500 transition-colors">
                Privacy Policy
              </Link>
              <Link to="/terms" className="hover:text-yellow-500 transition-colors">
                Terms of Service
              </Link>
              <Link to="/cancellation" className="hover:text-yellow-500 transition-colors">
                Cancellation Policy
              </Link>
              <Link to="/sitemap" className="hover:text-yellow-500 transition-colors">
                Sitemap
              </Link>
            </div>
          </div>
          
          {/* Address Line */}
          <p className="text-center text-xs text-gray-600 mt-4">
            Safe Track Cab Service | Regd. Office: Chennai, Tamil Nadu, India
          </p>
        </div>

        {/* Simple Developer Credit with Logo */}
        <div className="mt-6 pt-4 border-t border-gray-800/50">
          <div className="flex items-center justify-center gap-2 text-sm">
            {/* <FaCode className="text-yellow-500 text-xs" /> */}
            <p className="text-gray-500">
              Developed with by{' '}
              <a 
                href={developer.website}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-yellow-500 transition-colors font-medium inline-flex items-center gap-1"
              >
                {developer.name}
                {/* Developer Logo */}
                <div style={{background:"white", borderRadius: "10px", padding: "2px", display: "inline-flex", alignItems: "center", justifyContent: "center"}}>
                  <img src={logo1} alt="Developer Logo" className="w-4 h-4 inline-block" />
                </div>
              </a>
              {/* <span className="text-gray-600 mx-1">•</span> */}
              <span className="text-gray-600 text-xs">{developer.role}</span>
            </p>
          </div>
          
          {/* Optional: Small additional credit line */}
          {/* <p className="text-center text-[10px] text-gray-700 mt-2">
            Crafted with precision for Safe Track Cab Service
          </p> */}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
